const log =
  (logger: typeof console.log) =>
  (...messages: any[]) => {
    if (import.meta.env.DEV || import.meta.env.MODE === 'test')
      logger(...messages)
  }

export const logInfo = log(console.info)
export const logWarn = log(console.warn)
export const logError = log(console.error)
